<template>
    <div class="registration">
        <!-- 分类 -->
        <div class="registration-tab-list">
            <div class="registration-tab-list-box" v-for="(item,index) in tabList" :key="index" @click="clickTab(index)">
                <div class="registration-tab-list-box-title" :style="{color:active==index ? '#3D7EFF':''}">{{item.title}}</div>
                <div class="registration-tab-list-box-line" :style="{background:active==index ? '#3D7EFF':''}"></div>
            </div>
        </div>
        <!-- <loading v-if="listLoading"></loading> -->
        <!-- 赛事 -->
        <div class="registration-match" v-loading="listLoading">
            <div class="registration-match-box" v-for="(item,index) in list" :key="index">
                <img :src="item.cover" alt="">
                <div class="registration-match-box-right">
                    <div class="registration-match-box-right-title">{{item.name}}</div>
                    <div class="registration-match-box-right-content">
                        <div class="registration-match-box-right-content-box">
                            <img src="../../../assets/image/company.png" alt="">
                            <span>举办单位：{{item.organizer}}</span>
                        </div>
                        <div class="registration-match-box-right-content-box">
                            <img src="../../../assets/image/signUpTime.png" alt="">
                            <span>报名时间：{{item.enroll_start_at}} 至 {{item.enroll_end_at}}</span>
                        </div>
                        <div class="registration-match-box-right-content-box">
                            <img src="../../../assets/image/matchTime.png" alt="">
                            <span>赛事时间：{{item.start_at}} 至 {{item.end_at}}</span>
                        </div>
                        <div class="registration-match-box-right-content-box">
                            <img src="../../../assets/image/matchAddress.png" alt="">
                            <span>举办地点：{{item.venue}}</span>
                        </div>
                    </div>
                    <!-- 按钮 -->
                    <div class="registration-match-box-right-content-btn">
                        <el-button type="primary" @click="cancelEnroll(item.id)">申请取消</el-button>
                        <el-button type="default" @click="goDetails(item.id)">查看详情</el-button>
                    </div>
                </div>
            </div>
        </div>
        <div class="nodata" v-if="list.length==0&&!listLoading">
            <img src="../../../assets/image/noMatch.png" alt="">
            <span>暂无比赛</span>
        </div>
        <p v-if="noMore && list.length>0">已经到底了~</p>
    </div>
</template>
<script>
import request from "@/utils/request";
import loading from '@/components/loading/loading.vue'
export default {
    components: { loading },
    data(){
        return{
            listLoading:true,
            active:0,
            tabList:[
                {
                    title:'全部'
                },
                {
                    title:'报名中'
                },
                {
                    title:'报名结束'
                },
                {
                    title:'进行中'
                },
                {
                    title:'已结束'
                },
                {
                    title:'取消报名'
                }
            ],
            list:[],
            query:{
                page:1,
                limit:10,
                status:''
            },
        }
    },
    created(){
        if(this.$store.getters.getUserInfo.student_id){
            this.getList()
        }
    },
    mounted() {
      window.addEventListener('scroll', this.handleScroll);  // 监听（绑定）滚轮滚动事件
    },
    destroyed() {
      window.removeEventListener('scroll', this.handleScroll);   //  离开页面清除（移除）滚轮滚动事件
    },
    methods:{
         handleScroll() {
            var scrollTop = document.documentElement.scrollTop||document.body.scrollTop;
            //变量windowHeight是可视区的高度
            var windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
            //变量scrollHeight是滚动条的总高度
            var scrollHeight = document.documentElement.scrollHeight||document.body.scrollHeight;
               //滚动条到底部的条件
            if(scrollTop+windowHeight==scrollHeight){
                if(!this.noMore){
                    console.log('触底')
                    this.query.limit += 10
                    if(this.$store.getters.getUserInfo.student_id){
                        this.getList()
                    }
                }
                //写后台加载数据的函数
                // console.log("距顶部"+scrollTop+"可视区高度"+windowHeight+"滚动条总高度"+scrollHeight);
            }   
        
        },
        // 取消报名
        cancelEnroll(id){
             this.$confirm('此操作将取消报名, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                //点击确定的操作(调用接口)
                request({
                    url: "/api/userend/match/enrollCabcelApple",
                    method: "post",
                    params: {match_id:id}
                }).then(response => {
                    this.$message.success("已发送申请，请耐心等待...")
                });
            }).catch(() => {
                //几点取消的提示
            });
        },
        // 前往详情
        goDetails(id){
            this.$router.push({
                path:"/match/details",
                query:{
                    id:id
                }
            })
        },
        clickTab(index){
            this.list=[]
            this.active=index
            if(index==0){
                this.query.status=''
            }else{
                this.query.status=index+1
            }
            this.getList()
        },
        // 比赛列表
        getList() {
            this.listLoading = true;
            this.noMore=false
            request({
                url: "/api/userend/user/matchEnroll",
                method: "get",
                params: this.query
            }).then(response => {
                this.list = response.data;
                this.listLoading = false;
                if(this.list.length < this.query.limit){
                    this.noMore=true
                }
                console.log(this.list,'this.list')
            });
        },
    }
}
</script>
<style lang="scss">
.el-loading-spinner{
    margin-top: 80px;
}
    .registration{
        background: #ffffff;
        border-radius: 8px;
        padding: 30px;
        p{
            text-align: center;
            padding: 5px 0 15px 15px;
        }
        .nodata{
                height: calc(100vh - 260px); 
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                img{
                    width: 407px;
                    height: 355px;
                }
                span{
                    font-size: 22px;
                    font-family: Microsoft YaHei;
                    font-weight: 400;
                    color: #999999;
                }
            }
        .registration-tab-list{
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            padding-bottom: 20px;
            .registration-tab-list-box{
                cursor: pointer;
                margin-right: 50px;
                .registration-tab-list-box-title{
                    font-size: 20px;
                    font-family: PingFangSC-Medium, PingFang SC;
                    font-weight: 500;
                    color: #858585;
                    margin-bottom: 5px;
                }
                .active{
                    color: #3D7EFF;
                }
                .registration-tab-list-box-line{
                    width: 40px;
                    height: 4px;
                    margin: 0 auto;
                    border-radius: 6px;
                }
            }
        }
        .registration-match{
            margin-bottom: 40px;
           .registration-match-box{
                // margin-top: 40px;
                display: flex;
                flex-direction: row;
                justify-content: flex-start;
                padding: 20px 0;
                border-top: 1px solid #F9FAFD;
                img{
                    width: 482px;
                    height: 264px;
                    border-radius: 8px;
                }
                .registration-match-box-right{
                    height: 264px;
                    margin-left: 20px;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    .registration-match-box-right-title{
                            font-size: 24px;
                            font-family: PingFangSC-Medium, PingFang SC;
                            font-weight: 500;
                            color: #1E2134;
                    }
                    .registration-match-box-right-content{
                        .registration-match-box-right-content-box{
                            margin-top: 20px;
                                display: flex;
                                flex-direction: row;
                                justify-content: flex-start;
                                align-items: center;
                                img{
                                width: 20px;
                                height: 20px;
                                margin-right: 10px;
                                }
                                .span{
                                    font-size: 18px;
                                    font-family: PingFangSC-Regular, PingFang SC;
                                    font-weight: 400;
                                    color: #506176;
                                }
                            }
                        }
                        .registration-match-box-right-content-btn{
                            display: flex;
                            flex-direction: row;
                            justify-content: flex-start;
                            margin-top: 26px;
                            .el-button{
                            &:nth-child(1){
                                margin-right: 20px;
                            }
                                &:nth-child(2){
                                    width: 104px;
                                    height: 40px;
                                    background: #F9FAFD;
                                    border-radius: 4px;
                                }
                            }
                        }
                    }
            } 
        }
    }
</style>